import axios from 'axios';

export default {
    postScheduleAppointment(cb, { data, dealerId, clientToken }) {
        axios
            .post('https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/appointment', 
                data, {
                headers: {
                        Authorization: `Bearer ${clientToken}`,
                        Dealer: dealerId
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getClinicInformation(cb, { clinicUrl, dealerId, clientToken }) {
        axios
            .get('https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/Clinic', {
                params: {
                    clinicUrl
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getAppointmentTimeslots(cb, { startDate, endDate, appointmentType, clinicId, dealerId, clientToken }) {
        axios
            .get('https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/Appointment/timeslots', {
                params: {
                    startDate,
                    endDate,
                    appointmentType,
                    clinicId
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getCompanionTypes(cb, { dealerId, clientToken }) {
        axios
            .get('https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/CompanionType', {
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    }
};
